<template>
	<div>
		<div id="map-container"></div>
	</div>
</template>

<style scoped>
	#map-container {
		width: 100%;
		height: 400px;
	}
</style>

<script>
import '../../../node_modules/leaflet/dist/leaflet.css'
import L from 'leaflet'

export default {
	name: "Map",
	data() {
		return {
			map: null,
            tileLayer: null,
            center: ''
		}
	},
	created(){
		this.center = [39.747112,-8.932571]
	},
	mounted() {
		this.setupLeafletMap()
	},
	methods: {
		setupLeafletMap() {
			this.map = L.map('map-container', {
				zoomControl: true,
				scrollWheelZoom: false,
				renderer: L.svg()
			}).setView(this.center, 17)

			var mapMarker = L.icon({
			    iconUrl: '/images/map_marker.png',
			    iconSize: [64, 84], // size of the icon
			    iconAnchor:  [30,80],
			});

			this.tileLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
				minZoom: 2,
				maxZoom: 20,
				preferCanvas: true,
				noWrap: true
			})

			L.marker(this.center, {icon: mapMarker}).addTo(this.map).on('click', mapDirections)

			//L.circleMarker(this.center).addTo(this.map).on('click', mapDirections)

			function mapDirections() {
				window.open('https://www.google.com/maps/place/Pessoalform-Empresa+De+Trabalho+Tempor%C3%A1rio+E+Forma%C3%A7%C3%A3o,+Lda./@39.7471422,-8.9347667,17z/data=!3m1!4b1!4m5!3m4!1s0xd220e9bab8e3d59:0xdb9bef6379d77b1!8m2!3d39.7471381!4d-8.932578?hl=pt-PT')
			}

			this.tileLayer.addTo(this.map)
            window.map = this.map
		}
	}
}
</script>